import "./src/styles/global.css";

// Fix anchor scrolling
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  return location.href.indexOf("#") > -1 ? false : true;
};

// Add Trustpilot
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    const script = document.createElement("script");
    script.src =
      "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.head.appendChild(script);
  }
};
